import innovate from '../../../../assets/homepage/members/innovate.svg';
import kickstart from '../../../../assets/homepage/members/kickstart.svg';
import L39 from '../../../../assets/homepage/members/level-39.svg';
import microsoft from '../../../../assets/homepage/members/microsoft-accelerator.svg';
import weAre from '../../../../assets/homepage/members/we-are-the-future.svg';
import octopusLabs from '../../../../assets/homepage/members/octopus.svg';

export default [
  {
    id: 1,
    logo: microsoft,
    width: 116,
    height: 52,
  },
  {
    id: 2,
    logo: octopusLabs,
    width: 131,
    height: 27,
  },
  {
    id: 3,
    logo: innovate,
    width: 148,
    height: 26,
  },
  {
    id: 4,
    logo: kickstart,
    width: 118,
    height: 33,
  },
  {
    id: 5,
    logo: L39,
    width: 60,
    height: 27,
  },
  {
    id: 6,
    logo: weAre,
    width: 83,
    height: 57,
  },
];
